import _objectSpread from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\objectSpread2.js";
import { defineComponent, reactive, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useState } from "@/hooks/mapGet/index.js";
import Comment from "@/components/list-detail/Comment/Comment.vue";
import Loading from "@/baseui/loading/loading.vue";
import Related from "./relatedVideo.vue";
export default defineComponent({
  name: "videoMain",
  setup: function setup() {
    var state = useState("Video", ["videoDetail"]);
    var route = useRoute();
    var store = useStore();
    var commentResInfo = reactive({
      id: route.params.id,
      limit: 20,
      offset: 0
    });
    /* 评论页数改变 */

    var changeCurrent = function changeCurrent(page) {
      state.videoDetail.value.comment = 0;
      commentResInfo.offset = (page - 1) * commentResInfo.limit;
      /* 如果id是mv则请求mv评论，否则请求视频评论 */

      if (+route.params.id) {
        store.dispatch("Video/getMvComment", commentResInfo);
      } else {
        store.dispatch("Video/getVideoComment", commentResInfo);
      }
    };

    watch(function () {
      return route.params.id;
    }, function (newV, oldV) {
      if (~route.path.indexOf("/videodetail")) {
        if (+newV) {
          store.dispatch("Video/getVideoDetail", {
            id: route.params.id,
            type: "mv"
          });
          store.dispatch("Video/getMvComment", commentResInfo);
        } else {
          store.dispatch("Video/getVideoDetail", {
            id: route.params.id,
            type: "video"
          });
          store.dispatch("Video/getVideoComment", commentResInfo);
        }
      }
    }, {
      immediate: true
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      commentResInfo: commentResInfo,
      changeCurrent: changeCurrent
    });
  },
  components: {
    Comment: Comment,
    Loading: Loading,
    Related: Related
  }
});